declare var ajax_url;
export class noble_checkout {
    constructor() {
        if (jQuery('body.page-template-checkout-wrapping').length || jQuery('body.page-template-checkout-sample').length) {
            // Only loads on the checkout
            this.init();
        }
    }

    init() {
        this.samplePageFunctions();
        this.wrappingPageFunctions();
    }

    samplePageFunctions() {
        let $ = jQuery;
        jQuery(document).on('ready', () => {


            // Ajax form data to add_sample_to_cart() 
            $(".sample-checkout").on("click", function (e) {

                // Prevent default submit
                e.preventDefault();

                // Get data from form
                var sample = $("input[name='sample']:checked").val();
                // var giftbox = $("input#giftbox").prop('checked');
                // var message = $("#gift-message").val();

                if (!sample) {
                    $('.sample-alert').show();
                    $('.popup-overlay').show();
                } else {

                    // show loader
                    $("#checkout-loader").css("display", "inline-block");

                    $.ajax({
                        type: 'post',
                        url: ajax_url,
                        data: {
                            'action': 'add_sample_to_cart',
                            'sample': sample,
                            // 'giftbox': giftbox,
                            // 'message': message,
                        },
                        success: function () {

                            // location.href = "/checkout-wrapping/";
                            $(".popup-overlay").hide();
                            $(".sample-alert").hide();
                            check_little_treasure();
                        },
                        // error: function (textStatus) {
                        //     console.log('failed: ' + textStatus);
                        // }
                    })
                }

            });

            function check_little_treasure() {
                let little_treasure = jQuery('input[name="little_treasure"]').val();
                if (!little_treasure) {
                    $('.little-treasure-alert').show();
                    $('.popup-overlay').show();
                } else {
                    location.href = "/checkout/";
                }
            }

            $(".sample-alert button.button").on("click", function (e) {
                e.preventDefault();
                $(".popup-overlay").hide();
                $(".sample-alert").hide();
                if (jQuery(this).hasClass('yes')) {
                    check_little_treasure();
                }
            });

            jQuery('.little-treasure-alert .no').on('click', function () {
                $.ajax({
                    type: 'post',
                    url: ajax_url,
                    data: {
                        'action': 'add_little_treasure_to_cart',
                    },
                    success: function (response) {
                        if (response.indexOf('success') > -1) {
                            location.href = "/checkout/";
                        }
                    },
                })
            });

        });

        this.sampleSlider();
    }

    sampleSlider() {
        jQuery(document).on('ready', () => {
            jQuery('.product-sample-grid').slick({
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 8,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            // infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            // infinite: true,
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            // infinite: true,
                        }
                    }
                ]
            });
        });
    }

    wrappingPageFunctions() {
        var $ = jQuery;
        jQuery(document).on('ready', function () {
            // toggle gift message form
            $(".add-gift-wrapping").on("click", function () {
                var title = $(this).closest(".cart-item-details").find('.item-title').html();
                var productID = $(this).val();
                $(".popup-overlay").css("display", "block");
                $(".gifting-details-form-wrap").css("display", "block");

                //Toggle between gift wrap and pre wrap
                if (this.getAttribute('data-pre_wrapped') == 'prewrap') {
                    $(".gifting-details-form-wrap .gift_wrap_heading").html('Add Gift Message For:');
                    $(".gifting-details-form-wrap #gifting-submit").val('Add Gift Message');
                } else {
                    $(".gifting-details-form-wrap .gift_wrap_heading").html('Add Gift Wrap For:');
                    $(".gifting-details-form-wrap #gifting-submit").val('Add Gift Wrap');
                }

                $(".gifting-details-form-wrap .cart-item-product-name").html(title);
                $(".gifting-details-form-wrap .gift-message").val('');
                $(".gifting-details-form-wrap .product-id").val(productID as number);
            });
            $(".gifting-details-form-wrap .close").on("click", function () {
                $(".gifting-details-form-wrap").css("display", "none");
                $(".popup-overlay").css("display", "none");
            });
            $(".gift-wrap-details .edit-buttons .edit").on("click", function () {
                var title = $(this).closest(".cart-item-details").find('.item-title').html();
                var productID = $(this).val();
                var message = $(this).closest(".gift-wrap-details").find('.message .msg-text').html();

                //Toggle between gift wrap and pre wrap
                if (this.getAttribute('data-pre_wrapped') == 'prewrap') {
                    $(".gifting-details-form-wrap .gift_wrap_heading").html('Add Gift Message For:');
                    $(".gifting-details-form-wrap #gifting-submit").val('Add Gift Message');
                } else {
                    $(".gifting-details-form-wrap .gift_wrap_heading").html('Add Gift Wrap For:');
                    $(".gifting-details-form-wrap #gifting-submit").val('Add Gift Wrap');
                }

                $(".popup-overlay").css("display", "block");
                $(".gifting-details-form-wrap").css("display", "block");
                $(".gifting-details-form-wrap .cart-item-product-name").html(title);
                $(".gifting-details-form-wrap .gift-message").val(message);
                $(".gifting-details-form-wrap .product-id").val(productID as number);
            });


            // var ajax_url = "<?php echo admin_url('admin-ajax.php'); ?>";

            // add gifting to cart item
            $("#gifting-submit").on("click", function (e) {

                // Prevent default submit
                e.preventDefault();

                // Get data from form
                var productID = $(".product-id").val();
                var message = $(".gift-message").val();
                // Show loader
                $('#gifting-details-form .gift-form-loader').css('display', 'block');

                jQuery.post(ajax_url, {
                    'action': 'add_gifting_to_cart_item',
                    'productID': productID,
                    'message': message,
                }, function (response) {

                    console.log("RESPONSE: ", response);

                    // Hide loader
                    $('#gifting-details-form .gift-form-loader').hide();

                    // failed if response empty
                    if (response == 'error303') {
                        // Show success message in form output div
                        $("#gifting-details-form .error-message").show();
                    } else {

                        // update cart item message
                        $(".cart-item.product-" + productID + " .add-gift-wrapping").addClass('active');
                        $(".cart-item.product-" + productID + " .gift-wrap-details").show();
                        $(".cart-item.product-" + productID + " .gift-wrap-details .msg-text").html(response);

                        // hide message popup form
                        $(".gifting-details-form-wrap").css("display", "none");
                        $(".popup-overlay").css("display", "none");
                    }

                });

            });

            // remove gifting from cart item
            $(".edit-buttons .remove").on("click", function (e) {

                // Prevent default submit
                e.preventDefault();

                // Get data from form
                var productID = $(this).val();

                // Show loader
                $(".cart-item.product-" + productID + " .cart-item-loader").show();

                jQuery.post(ajax_url, {
                    'action': 'remove_gifting_from_cart_item',
                    'productID': productID,
                }, function (response) {

                    console.log("RESPONSE: ", response);

                    // Hide loader
                    $(".cart-item.product-" + productID + " .gift-wrap-details").hide();

                    // failed if response empty
                    if (response == 'error304') {
                        // Show success message in form output div
                        // $("#gifting-details-form .error-message").show();
                    } else {

                        // update cart item message
                        $(".cart-item.product-" + productID + " .gift-wrap-details .msg-text").empty();
                        $(".cart-item.product-" + productID + " .add-gift-wrapping").removeClass("active");
                        $(".cart-item.product-" + productID + " .gift-wrap-details").removeClass("active");
                        $(".cart-item.product-" + productID + " .cart-item-loader").hide();

                        // hide message popup form
                        // $(".gifting-details-form-wrap").css("display", "none");
                        // $(".popup-overlay").css("display", "none");
                    }

                });

            })

        });
    }
}